

import $ from 'jquery';
import { copyTextFromElement, getOptionsFromDataset, triggerEvent } from '../util/dom.js';
import { estimatedFCP, now } from '../util/system.js';

// import mpro from '../mpro';

// Lazy loaded plugin list (selector => initFunction)
const pluginSelectors = {

	/**
	 * Plugin: Replace lang urls with current page url
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'a[data-replace-locale-url]': ($collection) => {

		const pageLanguageUrls = mpro.config.page.language_urls || {};

		$collection.each(function() {
			const $link = $(this);
			const data = $link.data();
			if (pageLanguageUrls[data.replaceLocaleUrl]) {
				$link.attr('href', pageLanguageUrls[data.replaceLocaleUrl]);
			}
		});
	},

	/**
	 * Plugin: ScrollToHash
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'a[href^="#"]': ($collection) => {

		const $B = mpro.get$B();
		const $header = $B.find('#header');
		const $headerWrapper = $B.find('#header_wrapper');
		const $headerMenuWrapper = $B.find('#header_menu_wrapper');

		let headerWrapperOuterHeight = $headerWrapper.is(':visible') ? $headerWrapper.outerHeight() : 0;
		// Recalculate headerWrapper height based in sticky header style
		if ($header.is('[data-sticky-header]') && $headerWrapper.is(':visible')) {
			const $headerClone = $header.clone();
			$headerClone.find('#header_menu_wrapper').remove();
			$headerClone.css('visibility', 'hidden');
			$headerClone.addClass('header--sticky');
			$headerClone.appendTo($B);
			headerWrapperOuterHeight = $headerClone.find('#header_wrapper').outerHeight();
			$headerClone.remove();
		}

		let offsetY =
			headerWrapperOuterHeight +
			($headerMenuWrapper.length && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0);

		$collection.each(function() {

			const $link = $(this);
			$link.on('click.scroll-to-hash', () => {

				const href = $link.attr('href').replace('#', '');

				// Skip empty hash
				if (!href || Number.isInteger(href)) {
					return void 0;
				}

				const selector = $.escapeSelector(href);
				let $target = $('#' + selector);
				if ($target.length === 0) {
					$target = $('a[name="' + selector + '"]');
				}

				if ($target.length > 0) {
					let blink = $link.data('blink');
					if (typeof blink === 'undefined') {
						blink = true;
					}
					let speed = $link.data('speed');
					if (typeof blink === 'undefined') {
						speed = 266;
					}
					mpro.scrollToElement($target, { speed: speed, focusMiddle: false, blink: blink, offsetY: $link.data('offset-y') || offsetY });
					if (typeof $link.data('no-hash') === 'undefined') {
						window.location.hash = href;
					}
					return false;
				}

				return void 0;
			});
		});
	},

	/**
	 * Honeypot fields handling
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'div.mph-data': ($collection) => {

		for (const element of $collection) {
			const $element = $(element);
			const $input = $element.find('input');
			/** @type {JQuery<HTMLFormElement>} */ // @ts-ignore
			const $form = $element.closest('form');
			const options = $element.data('mph') || {};
			let delay = Number(options.d || 0);
			// Delay might be in seconds
			delay = (delay > 1000) ? delay : (delay * 1000);
			// Add 1 second to the delay, to account for js loading time
			// ? Note: Not needed
			delay = (delay > 0) ? (delay/*  + estimatedFCP */) : 0;

			console.debug('🔶 Setting mph for form (with delay: %o): %o', delay, $form[0]);

			const clear = (type = '') => {
				console.debug('🔷 Clearing mph for form (event type: %o): %o', type, $form[0]);
				$input.val('');
				$form.off('.mph');
			};

			$form.on('focusin.mph focusout.mph keydown.mph', (e) => {
				if (now() > delay) {
					clear(e.type);
				}
			});
		}
	},

	/**
	 * Single Selection handler
	 * @param {*} $collection
	 */
	'[data-single-selection]': ($collection) => {

		for (const elem of $collection) {
			const $elem = $(elem);
			const data = $elem.data('singleSelection') || {};
			const isVisible = $elem.is(':visible');
			const { options } = data;

			let $options = $();

			if (Array.isArray(options)) {
				for (const { id: optionId, elements } of options) {

					/** @type {JQuery<HTMLInputElement>} */ // @ts-ignore
					const $option = $elem.find('#' + optionId);
					if ($option.length === 0) {
						continue;
					}
					$options = $options.add($option);

					// Get the container
					const $optionContainer = $option.closest('[data-single-selection-option-container]');
					if ($optionContainer.length === 0) {
						continue;
					}

					// Add the container to the option
					$option.data('$ssContainer', $optionContainer);
					let $elements = $();

					// Get the elements
					if (elements && Object.keys(elements).length > 0) {
						for (const elementId of Object.values(elements)) {
							const $element = $elem.find('#' + elementId);
							if ($element.length === 0) {
								continue;
							}
							$elements = $elements.add($element);
						}
					}

					// Add the elements to the option
					$option.data('$ssElements', $elements);

					const $elementContainers = $elem.find(`[data-single-selection-element-container="${optionId}"]`);
					$option.data('$ssElementContainers', $elementContainers);

					$option.off('change.single-selection-handler').on('change.single-selection-handler', function() {

						if (this.checked) {
							// Enable self
							$elements.prop('disabled', false);
							// Alter the visibility of elements only if the main container is visible
							if (isVisible) {
								$elementContainers.show();
							}
							// Disable others
							$options.not(this).each(function() {
								const $otherOption = $(this);
								const $otherElements = $otherOption.data('$ssElements');
								const $otherElementContainers = $otherOption.data('$ssElementContainers');
								if ($otherElements?.length > 0) {
									$otherElements.prop('disabled', true);
									$otherElementContainers && $otherElementContainers.hide();
								}
							});
						}
						else {
							// Disable self
							$elements.prop('disabled', true);
							// Alter the visibility of elements only if the main container is visible
							if (isVisible) {
								$elementContainers.hide();
							}
							// Enable others
							$options.not(this).each(function() {
								const $otherOption = $(this);
								const $otherElements = $otherOption.data('$ssElements');
								const $otherElementContainers = $otherOption.data('$ssElementContainers');
								if ($otherElements?.length > 0) {
									$otherElements.prop('disabled', false);
									$otherElementContainers && $otherElementContainers.show();
								}
							});
						}
					});
				}
			}

			for (const option of $options) {
				$(option).triggerHandler('change.single-selection-handler');
			}
		}
	},

	/**
	 * Plugin: Filter Slider (lazy loaded)
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'.filter-slider': ($collection) => {

		$collection.each(function() {
			mpro.initFilterSlider(this);
		});
	},

	/**
	 * Plugin: Collapse elements
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'[data-toggle=collapse]': ($collection) => {
		$collection.on('click', (e) => {
			const $trigger = $(e.currentTarget);
			let $target = $($trigger.data('target'));
			if ($target.length === 0) {
				$target = $trigger.next();
			}

			if ($trigger.attr('aria-expanded') === 'true') {
				$trigger.attr('aria-expanded', 'false');
				$target.removeClass('show');
			}
			else {
				$trigger.attr('aria-expanded', 'true');
				$target.addClass('show');
			}
		});
	},

	/**
	 * Plugin: Switch
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'[data-toggle=switch]': ($collection) => {
		$collection.on('click', (e) => {
			const $trigger = $(e.currentTarget);
			let $target = $($trigger.data('target'));
			if ($target.length === 0) {
				$target = $trigger.next();
			}

			if ($trigger.attr('aria-expanded') === 'true') {
				$trigger.attr('aria-expanded', 'false');
				$trigger.show();
				$target.removeClass('show');
			}
			else {
				$trigger.attr('aria-expanded', 'true');
				$trigger.hide();
				$target.addClass('show');
			}
		});
	},

	/**
	 * Plugin: Copy text from element
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'[data-copy]': ($collection) => {
		$collection.on('click', function(e) {
			copyTextFromElement(this);
		});
	},

	/**
	 * Plugin: Readmore.js (lazy)
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'[data-read-more]': async ($collection) => {

		await import('readmore-js');

		for (const elem of $collection) {
			const $elem = $(elem);
			const options = $elem.data('readMore') || {};
			$elem.readmore({ ...((Object.prototype.toString.call(options) === '[object Object]') ? options : {}) });
		}
	},

	/**
	 * Plugin: Tick/Flip counter
	 *
	 * @param {JQuery} $collection
	 */
	'.tick[data-tick-counter]': async ($collection) => {

		// Import the tick plugin to handle counters
		const { 'default': Tick } = await import('../modules/tick.js');

		for (const elem of $collection) {
			Tick.DOM.create(elem);
		}
	},

	/**
	 * Plugin: mp-counter (lazy)
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'mp-counter': async ($collection) => {

		// Just import the custom element implementation, nothing else is needed
		await import('../modules/counter.js');

		for (const elem of $collection) {
			console.log('mpCounter: %o', elem);
		}
	},

	/**
	 * Plugin: noUI slider
	 *
	 * @param {JQuery} $collection
	 */
	'[data-range-slider]': async ($collection) => {

		// Import the tick plugin to handle counters
		const noUiSlider = await import('nouislider');

		for (const elem of $collection) {
			const $elem = $(elem);
			const options = getOptionsFromDataset($elem[0], 'rangeSlider', true);
			noUiSlider.create(elem, options);
		}

		// Trigger plugin ready event
		triggerEvent(document, 'mp-plugin-loaded:range-slider', { bubbles: false, cancelable: false, detail: { noUiSlider } });
	},

	/**
	 * Plugin: Toggle and disable form elements
	 *
	 * @param {JQuery<Element>} $collection
	 */
	'input[data-toggle=form]': ($collection) => {
		$collection.on('click', (e) => {
			const $trigger = $(e.currentTarget);
			let $target = $($trigger.data('target'));
			
			if ($target.length === 0) {
				$target = $trigger.next();
			}

			if ($trigger.attr('aria-expanded') === 'true') {
				$trigger.attr('aria-expanded', 'false');
				$target.slideUp('fast', () => $target.find('input, textarea').attr('disabled', 'disabled'));
			}
			else {
				$trigger.attr('aria-expanded', 'true');
				$target.find('input, textarea').removeAttr('disabled');
				$target.slideDown('fast', () => $target.find('input, textarea').removeAttr('disabled'));
			}
		});
	},

	// /**
	//  * Plugin: stripe payment
	//  *
	//  * @param {JQuery} $collection
	//  */
	// '[data-stripe-payment]': async ($collection) => {

	// },
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// Init plugins
	for (const selector of Object.keys(pluginSelectors)) {
		const handler = pluginSelectors[selector];
		const $collection = $container.find(selector);

		// Apply the handler to the collection
		if ($collection.length > 0) {
			handler($collection);
		}
	}
});

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	// var $W = mpro.get$W();
	const $D = mpro.get$D();
	const $B = mpro.get$B();

	// Disable history scroll restoration
	if (window.location.hash && ('scrollRestoration' in window.history)) {
		// Disable popstate auto-scrolling
		window.history.scrollRestoration = 'manual';
	}

	// Auto-Scroll to hash element with taking into account the header offset
	const docHash = $.escapeSelector(window.location.hash.replace('#', ''));
	if (docHash !== '') {
		let $scrollToElement = $('#' + docHash);
		if ($scrollToElement.length === 0) {
			$scrollToElement = $('a[name="' + docHash + '"]');
		}
		// Hash is already set
		if ($scrollToElement.length > 0) {
			mpro.scrollToElement($scrollToElement, { speed: 266, focusMiddle: false, blink: true });
		}
	}

	// Add browser/os classes
	const ua = mpro.explainUa();
	// Add touch / no-touch class on body
	$D.addClass(mpro.isTouchDevice() ? 'touch' : 'no-touch' + ' browser-' + ua.browser + ' platform-' + ua.os);

	// Disable hash for #0
	$B.on('click', 'a[href="#0"]', (e) => {
		e.preventDefault();
	});
	// Stop propagation
	$B.on('click mousedown', '.stop-propagation', (e) => {
		e.stopPropagation(); e.stopImmediatePropagation();
	});
	// Make sure the disabled class make the element truly disabled
	$B.on('click.disabled', 'a.disabled, button.disabled, span.disabled, .btn.disabled', false);
	// Prevent default actions
	$B.on('click.prevent-default', '[data-prevent-default], [data-fancybox-close]', function(e) {
		// Continue as normal for cmd clicks etc
		if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
			return;
		}

		const $trigger = $(this);
		// Only if in a fancy container
		if ($trigger.is('[data-fancybox-close]') && $trigger.closest('.fancy-wrapper').length === 0) {
			// Not in a fancy container - do nothing
			return;
		}

		e.preventDefault();
	});

	// Handle history back on click
	$B.on('click.history-back', '.history-back', (e, _data) => {
		if (window.history.length > 1) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			window.history.back();
		}
	});

	// Handle click redirects
	mpro.handleClickRedirect('[data-href]', 'data-href');

	// Handle append return
	mpro.handleUrlReturn('a[data-return]');

	// Change url from select delegate binding
	// ---------------------------------------
	$B.on('change.redirect-location', 'select[data-onchange-url]', function(e) {
		const jqThis = $(this);
		const url = jqThis.find('option:selected').data('url');
		if (this.name === 'sort_options') {
			if (typeof window.dataLayerTrigger === 'function') {
				window.dataLayerTrigger.call(this, {
					'event': 'product_sort',
					'value': jqThis.find('option:selected').text(),
				});
			}
		}
		if (url) {
			mpro.setLocation(url);
		}
		else {
			const val = jqThis.val();
			const value = Array.isArray(val) ? val.join(',') : (String(val));
			mpro.setLocation(mpro.updateUrlParams(window.location.href, jqThis.attr('name'), value));
		}
	});

	// Timezone detection
	let jsTimezone;
	let cookieTimezone;
	try {
		jsTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		cookieTimezone = mpro.Cookies.get('jstz');
	}
	catch (error) {
		console.warn('Error reading timezone: %o', error);
	}

	// Timezone info not in cookie
	if (jsTimezone && !cookieTimezone) {
		// Detect the timezone and save it in cookie (for 1 day)
		mpro.Cookies.set('jstz', jsTimezone, { expires: 1 });
	}
});
